import { render, staticRenderFns } from "./RestaurantDetail copy.vue?vue&type=template&id=00b9a427&"
import script from "./RestaurantDetail copy.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetail copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
